import type { UserDto } from '@/api/generator';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouterStore = defineStore('router', () => {
  const userAdded = ref<UserDto | null>(null);

  // explicitly allow direct manipulation (exception for this special kind of store)
  return {
    userAdded,
  };
});
